import { ThemeOptions } from "@material-ui/core/styles/createTheme";

const theme: ThemeOptions = {
  overrides: {
    MuiButton: {
      containedPrimary: {
        color: "white",
      },
    },

    MuiCssBaseline: {
      "@global": {
        CSSProperties: {
          boxSizing: "border-box",
        },
      },
    },
  },
  palette: {
    background: {
      default: "#FDFFFC",
      paper: "#FDFFFC",
    },
    common: {
      black: "#001427",
      white: "#FDFFFC",
    },
    error: {
      main: "#EC4E20",
    },
    info: {
      main: "#3E7CB1",
    },
    primary: {
      main: "#494b8f",
    },
    secondary: {
      main: "#696D7D",
    },
    success: {
      main: "#60D394",
    },
    warning: {
      main: "#FFBF00",
    },
  },
};

export default theme;



// WEBPACK FOOTER //
// ./src/theme.ts